var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"footer",attrs:{"absolute":"","padless":"","dark":""}},[_c('div',{staticClass:"mx-auto"},[_c('language-select',{staticClass:"py-5"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }